import { obterModeloAsync } from "../../services/modeloService";

const atualizarModelos = async ({ commit }) => {
    const modelos = await obterModeloAsync();
    commit('atualizarModelos', modelos);
}

const atualizarModelo = ({ commit }, modelo) => {
    commit('atualizarModelo', modelo);
}

export default {
    atualizarModelos,
    atualizarModelo
}